import { call, takeEvery, select } from 'redux-saga/effects';
import { TRACK_AUDIO_IMPORT_CLICK, TRACK_AUDIO_PLAY } from 'JS/actionCreators/trackingActions';
import { DELETE_AUDIO, SAVE_AUDIO, UPDATE_AUDIO_CONFIG } from 'JS/actionCreators/scribeActions';
import { SET_USER_SETTING } from 'JS/actionCreators/userSettingsActions';
import { AUDIO_RECORDING_START, AUDIO_RECORDING_CANCEL } from 'JS/actionCreators/uiActions';
import { RECORD_WITH_PLAYBACK_USER_SETTING_KEY } from 'JS/config/userSettingsKeys';
import getAudioFileDuration from 'JS/shared/helpers/getAudioFileDuration';

import { track } from '../mixpanelProvider';

const getRecordWithPlaybackUserSetting = state =>
  !!state.userSettings?.settings?.[RECORD_WITH_PLAYBACK_USER_SETTING_KEY];

function* trackAudioImportClick({ scribeId, audioType }) {
  yield call(track, 'Open Audio Upload', { 'Scribe ID': scribeId, 'Audio Type': audioType });
}

function* trackAudioRecordingStart({ scribeId, audioType }) {
  const recordWithPlayback = yield select(getRecordWithPlaybackUserSetting);
  yield call(track, 'Click Record Audio', {
    'Scribe ID': scribeId,
    'Audio Type': audioType,
    'Playback Enabled': recordWithPlayback
  });
}

function* trackAudioRecordingCancel({ scribeId, audioType }) {
  const recordWithPlayback = yield select(getRecordWithPlaybackUserSetting);

  yield call(track, 'Cancel Recording Audio', {
    'Scribe ID': scribeId,
    'Audio Type': audioType,
    'Playback Enabled': recordWithPlayback
  });
}

function* trackAudioPlay({ scribeId, audioSource, audioType, duration }) {
  yield call(track, 'Play Audio Playback', {
    'Scribe ID': scribeId,
    'Audio Source': audioSource || 'unknown',
    'Audio Type': audioType,
    'Audio Length (seconds)': duration
  });
}

function* trackAudioDelete({ scribeId, audioType, duration }) {
  yield call(track, 'Click Delete Audio', {
    'Scribe ID': scribeId,
    'Audio Type': audioType,
    'Audio Length (seconds)': duration
  });
}

function* trackAudioSave({ audio, scribeId, source, audioType }) {
  let duration;
  try {
    duration = yield call(getAudioFileDuration, audio);
  } catch (error) {
    console.error(error);
  }

  const recordWithPlayback = yield select(getRecordWithPlaybackUserSetting);

  yield call(track, 'Update Audio', {
    'Scribe ID': scribeId,
    'Audio Source': source,
    'Audio Length (seconds)': duration,
    'Audio Type': audioType,
    'Playback Enabled': recordWithPlayback
  });
}

function* trackSetUserSetting({ scribeId, setting, value }) {
  if (setting === RECORD_WITH_PLAYBACK_USER_SETTING_KEY) {
    yield call(track, value === true ? 'Enable Playback When Recording' : 'Disable Playback When Recording', {
      'Scribe ID': scribeId
    });
  }
}

function* trackUpdateAudioConfig({ scribeId, audioType, config }) {
  if (config.volume) {
    yield call(track, 'Set Audio Volume', {
      'Volume Control': config.volumeType,
      Volume: config.volume * 100,
      'Audio Type': audioType,
      'Scribe ID': scribeId
    });
  } else if (config.fadeOutDurationSeconds) {
    yield call(track, 'Set Audio Fade Out', {
      'Fade Out': config.fadeOutDurationSeconds,
      'Audio Type': audioType,
      'Scribe ID': scribeId
    });
  }
}

export default function* trackAudioSagas() {
  yield takeEvery(TRACK_AUDIO_IMPORT_CLICK, trackAudioImportClick);
  yield takeEvery(AUDIO_RECORDING_START, trackAudioRecordingStart);
  yield takeEvery(AUDIO_RECORDING_CANCEL, trackAudioRecordingCancel);
  yield takeEvery(TRACK_AUDIO_PLAY, trackAudioPlay);
  yield takeEvery(DELETE_AUDIO, trackAudioDelete);
  yield takeEvery(SAVE_AUDIO, trackAudioSave);
  yield takeEvery(SET_USER_SETTING, trackSetUserSetting);
  yield takeEvery(UPDATE_AUDIO_CONFIG, trackUpdateAudioConfig);
}
